import { FC } from 'react'
import { addCommaNumber } from '../../../../util/addCommaNumber'
import { StatisticBox } from './StatisticBox'
import Style from './StatisticBox.module.scss'
import { useTranslation } from 'react-i18next'

interface Props {
    statistic: {
        average: string
        count: number
    }
}

export const StatisticBoxes: FC<Props> = ({ statistic }) => {
    const { t } = useTranslation()

    let symbol = '+'
    if (Number(statistic.average) < 0) {
        symbol = ''
    }
    if (Number(statistic.average) === 0) {
        symbol = ''
    }

    const data = [
        {
            id: 1,
            title1: t('txt_n_of'),
            title2: t('txt_challenger'),
            value: addCommaNumber(statistic.count),
        },
        {
            id: 2,
            title1: t('txt_average'),
            title2: '%PNL',
            value: `${symbol}${statistic.average}%`,
        },
    ]
    return (
        <div className={Style.wrapper}>
            {data.map((re, index) => (
                <StatisticBox
                    key={index}
                    title1={re.title1}
                    title2={re.title2}
                    value={re.value}
                />
            ))}
        </div>
    )
}
